import utils from '@/utils';

const DELAYED_FOR = 100; // ms
const DEFAULT_OPACITY = 0.55;

export class CoverageOverlay extends google.maps.OverlayView {

  constructor(map, imageBaseUrl, operator, technology, opacity) {
    super();
    if (!map || !imageBaseUrl) {
      throw new Error('constructing error: no image or map, got image=' +
        imageBaseUrl + ' and map=' + map);
    }
    // Initialize all properties.
    this._image = imageBaseUrl;
    this._map = map;

    // Define a property to hold the image's div. We'll
    // actually create this div upon receipt of the onAdd()
    // method so we'll leave it null for now.
    this._div = null;
    this._bounds = null;
    this._zoom = null;
    this._operator = operator;
    this._technology = technology;
    this._opacity = opacity || DEFAULT_OPACITY;

    // Explicitly call setMap on this overlay.
    this.setMap(map);
  }

  onAdd() {

    let div = document.createElement('div');
    div.className = 'coverage-overlay';
    this._div = div;

    // Add the element to the "overlayLayer" pane.
    let panes = this.getPanes();
    panes.overlayLayer.appendChild(div);
  }

  draw() {
    if (!this._bounds || !this._zoom) return;
    // We use the south-west and north-east
    // coordinates of the overlay to peg it to the correct position and size.
    // To do this, we need to retrieve the projection from the overlay.
    let overlayProjection = this.getProjection();
    if (!overlayProjection) return;

    // Retrieve the south-west and north-east coordinates of this overlay
    // in LatLngs and convert them to pixel coordinates.
    // We'll use these coordinates to resize the div.
    let sw = overlayProjection.fromLatLngToDivPixel(this._bounds.getSouthWest());
    let ne = overlayProjection.fromLatLngToDivPixel(this._bounds.getNorthEast());

    // Resize the image's div to fit the indicated dimensions.
    let div = this._div;
    div.style.left = sw.x + 'px';
    div.style.top = ne.y + 'px';
    div.style.width = (ne.x - sw.x) + 'px';
    div.style.height = (sw.y - ne.y) + 'px';
    this.updateImage();
  }

  onRemove() {
    this._div.parentNode.removeChild(this.div_);
    this._div = null;
  }

  createImage(url) {
    let old = this._div.querySelector('img');
    if (old) this._div.removeChild(old);
    clearTimeout(this._imageTimeout);
    this._imageTimeout = setTimeout(() => {
      let img = document.createElement('img');
      img.className = 'coverage-overlay__img';
      img.alt = 'coverage overlay';
      img.style.opacity = this._opacity;
      img.src = url;
      this._div.appendChild(img);
    }, DELAYED_FOR);
  }

  updateImage() {
    if (!this._operator || !this._technology) {
      return;
    }
    let url = this._image;
    let fromLat = this._bounds.getSouthWest().lat();
    let fromLng = this._bounds.getSouthWest().lng();
    let toLat = this._bounds.getNorthEast().lat();
    let toLng = this._bounds.getNorthEast().lng();
    url = utils.url.appendParameter('fromlat', fromLat, url);
    url = utils.url.appendParameter('tolat', toLat, url);
    url = utils.url.appendParameter('fromlon', fromLng, url);
    url = utils.url.appendParameter('tolon', toLng, url);
    url = utils.url.appendParameter('zoom', this._zoom, url);
    url = utils.url.appendParameter('operator', this._operator, url);
    url = utils.url.appendParameter('technology', this._technology, url);
    this.createImage(url);
  }

  setBounds(bnds) {
    this._bounds = bnds;
  }

  setZoom(zoom) {
    this._zoom = zoom;
  }

  setImage(img) {
    this._image = img;
  }

  setOperator(o) {
    this._operator = o;
  }

  setTechnology(t) {
    this._technology = t;
  }

}